import { BaseProvider } from './base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
export class PaymentPlanService extends BaseProvider {
    constructor(globals, http, ls) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.baseUrl = 'invoicePaymentPlan';
    }
    pay(transactionId, data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/init/${transactionId}`;
            this.http.post(this.url, data)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    paySeveral(transactionId, data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/pay/${transactionId}`;
            this.http.post(this.url, data)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    getInstallmentById(installmentId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/installment/${installmentId}`;
            this.http.get(this.url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    getPaymentInfo(transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/info/${transactionId}`;
            this.http.get(this.url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    getPaymentList(transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/installment/process/${transactionId}`;
            this.http.get(this.url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    getTransactions() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/process`;
            this.http.get(this.url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
    paymentPlanValidation(ProcessId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/validation/${ProcessId}`;
            this.http.get(this.url)
                .subscribe((data) => { resolve(data); }, (err) => { reject(err); });
        });
    }
}
PaymentPlanService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentPlanService_Factory() { return new PaymentPlanService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService)); }, token: PaymentPlanService, providedIn: "root" });
